import { shopErrorFragment } from "@saleor/fragments/errors";
import { siteLanguageDetailsFragment } from "@saleor/fragments/siteLanguages";
import gql from "graphql-tag";

import { TypedMutation } from "../mutations";
import {
  SiteLanguageUpdate,
  SiteLanguageUpdateVariables
} from "./types/SiteLanguageUpdate";

const siteLanguageUpdate = gql`
  ${siteLanguageDetailsFragment}
  ${shopErrorFragment}
  mutation SiteLanguageUpdate($id: ID!, $input: SiteLanguageInput!) {
    siteLanguageUpdate(id: $id, input: $input) {
      errors: shopErrors {
        ...ShopErrorFragment
      }
      siteLanguage {
        ...SiteLanguageDetailsFragment
      }
    }
  }
`;
export const TypedSiteLanguageUpdate = TypedMutation<
  SiteLanguageUpdate,
  SiteLanguageUpdateVariables
>(siteLanguageUpdate);
